export default __webpack_public_path__ + "static/BasisGrotesque-Regular-5865aabdb73ffae61a3734057bd8b803.woff2";